module.exports = __webpack_public_path__ + "static/media/highStreet.8b98a81d.png";